if (window.customElements && !window.customElements.get('simple-tabs')) {
  class SimpleTabs extends HTMLElement {
    constructor() {
      super();
      // Tab elements
      this.bars = Array.from(this.querySelectorAll('[data-bar]'));
      this.contents = Array.from(this.querySelectorAll('[data-content]'));
      this.attachEvents();
    }

    // Bind click events to each tab header.
    attachEvents() {
      this.bars.forEach((bar, index) => {
        bar.addEventListener('click', () => this.showTab(index));
      });
    }

    // Activate the selected tab and its content.
    showTab(index) {
      this.resetState();
      this.bars[index]?.setAttribute('data-show', 'true');
      this.contents[index]?.setAttribute('data-show', 'true');
    }

    // Clear active state across all tabs.
    resetState() {
      this.bars.forEach(bar => bar.removeAttribute('data-show'));
      this.contents.forEach(content => content.removeAttribute('data-show'));
    }
  }

  window.customElements.define('simple-tabs', SimpleTabs);
}
